import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
export const TeamPage = () => {
  useEffect(() => {
    document.title = 'Team | Race Capital';
  }, []);
  const teamMembers = [{
    name: 'Alfred Chuang',
    title: 'General Partner',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781053668/Alfred_Race_tvayqz.png',
    slug: 'alfred-chuang'
  }, {
    name: 'Chris McCann',
    title: 'General Partner',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781047033/Chris_Headshot_New_-_Clear_wmmeid.png',
    slug: 'chris-mccann'
  }, {
    name: 'Matt McLaughlin',
    title: 'Senior Operating Partner, Capital Formation',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781056265/ChatGPT_Image_Jun_10_2026_at_02_50_39_AM_regtpp.png',
    slug: 'matt-mclaughlin'
  }, {
    name: 'Kelly Cheng',
    title: 'Partner, CFO',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781056952/ChatGPT_Image_Jun_10_2026_at_03_02_24_AM_wrcvwy.png',
    slug: 'kelly-cheng'
  }, {
    name: 'Edith Yeung',
    title: 'Venture Partner',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781053661/Edith_Race_sik95j.png',
    slug: 'edith-yeung'
  }, {
    name: 'Bernard Chan',
    title: 'Principal',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781046649/Bernard_Headshot_New_ak29dv.png',
    slug: 'bernard-chan'
  }, {
    name: 'Alim Giga',
    title: 'Principal',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781047503/ChatGPT_Image_Jun_10_2026_at_12_24_51_AM_p6wm3a.png',
    slug: 'alim-giga'
  }, {
    name: 'Mariah Cole',
    title: 'Executive Assistant, Office Manager',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781053659/Mariah_Race_xe9yxn.png',
    slug: 'mariah-cole'
  }];
  return <div className="w-full bg-white mt-20" data-id="element-458">
      {/* Combined Hero and Team Members Section */}
      <section className="w-full pt-20 pb-20 px-6 md:px-12 bg-white" data-id="element-459">
        <div className="max-w-7xl mx-auto" data-id="element-460">
          <div className="relative mb-6 overflow-visible" data-id="element-461">
            {/* Racing stripes decoration - animated and flowing */}
            <style jsx data-id="element-462">{`
              @keyframes fillFromLeft {
                from {
                  transform: scaleX(0);
                  transform-origin: left;
                }
                to {
                  transform: scaleX(1);
                  transform-origin: left;
                }
              }
              .racing-stripe {
                transform: scaleX(0);
                transform-origin: left;
                animation: fillFromLeft 0.8s ease-out forwards;
              }
              .racing-stripe:nth-child(1) {
                animation-delay: 0.1s;
              }
              .racing-stripe:nth-child(2) {
                animation-delay: 0.2s;
              }
              .racing-stripe:nth-child(3) {
                animation-delay: 0.3s;
              }
              .racing-stripe:nth-child(4) {
                animation-delay: 0.4s;
              }
            `}</style>
            <div className="absolute right-[12px] top-0 hidden md:flex flex-col space-y-2 pointer-events-none" data-id="element-463">
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/30 to-red-600/10" style={{
              width: '240px',
              marginLeft: '0px'
            }} data-id="element-464"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/35 to-red-600/15" style={{
              width: '200px',
              marginLeft: '40px'
            }} data-id="element-465"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/40 to-red-600/20" style={{
              width: '160px',
              marginLeft: '80px'
            }} data-id="element-466"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/45 to-red-600/25" style={{
              width: '120px',
              marginLeft: '120px'
            }} data-id="element-467"></div>
            </div>
            <h1 className="relative z-10 text-[clamp(2.5rem,5vw,4rem)] font-semibold text-[#070707] tracking-tight leading-[1.15]" data-id="element-468">
              Our Team
            </h1>
          </div>
          <p className="text-lg text-gray-600 max-w-3xl mb-16 leading-relaxed font-light" data-id="element-469">
            Race Capital is led by experienced entrepreneurs and investors with
            decades of experience to help entrepreneurs navigate the challenges
            of building category-defining businesses.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10" data-id="element-470">
            {teamMembers.map((member, index) => <div key={index} className="flex flex-col group" data-id="element-471">
                <Link to={`/team/${member.slug}`} className="block" data-id="element-472">
                  <div className="relative mb-4 aspect-square overflow-hidden rounded-2xl bg-gray-100 transition-all duration-300 group-hover:shadow-2xl" data-id="element-473">
                    <img src={member.image} alt={member.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-474" />
                  </div>
                  <h3 className="text-xl font-semibold text-[#070707] mb-2 group-hover:text-red-600 transition-colors" data-id="element-475">
                    {member.name}
                  </h3>
                  <p className="text-red-600 font-medium" data-id="element-476">{member.title}</p>
                </Link>
              </div>)}
          </div>
        </div>
      </section>
      {/* Values Section */}
      <section className="w-full py-20 px-6 md:px-12 bg-gradient-to-b from-gray-50/50 to-white" data-id="element-477">
        <div className="max-w-7xl mx-auto" data-id="element-478">
          <h2 className="text-4xl font-bold text-[#070707] mb-16 tracking-tight" data-id="element-479">
            Our Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-480">
            {[{
            icon: '⚮',
            title: 'Founder-First',
            description: 'Not a slogan—how we actually operate. Your company, your call. We give you our honest take, then back your decision fully.'
          }, {
            icon: '⚡',
            title: 'Partnership',
            description: "We view ourselves almost like a co-founder with minority ownership. In the hard moments, we're in it with you - not just checking up occasionally."
          }, {
            icon: '✦',
            title: 'Long Horizon',
            description: 'We optimize for the decade, not individual investments. Trust over optics, relationship over transaction.'
          }].map((value, index) => <div key={index} className="bg-white p-10 rounded-3xl border border-gray-100 hover:shadow-[0_4px_12px_rgba(0,0,0,0.06)] transition-all duration-300 group relative" data-id="element-481">
                <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-red-600 transform scale-y-0 group-hover:scale-y-100 transition-all origin-top rounded-l-3xl" data-id="element-482"></div>
                <div className="text-5xl text-red-600 mb-8 font-light" data-id="element-483">
                  {value.icon}
                </div>
                <h3 className="text-2xl font-semibold mb-4 text-[#070707]" data-id="element-484">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm" data-id="element-485">
                  {value.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
};